import React from "react";
import VerifiedIcon from "@mui/icons-material/Verified";

export default function CirlceCheckbox({ status, margin }) {
  const checkboxStyle = {
    color:
      status === "PENDING" || status === null
        ? "#FFC107"
        : status === "POST"
        ? "#008000"
        : status === "ERROR" || status === "CANCELLED"
        ? "#FF0000"
        : "#FFC107",
    margin: margin,
  };
  return <VerifiedIcon style={checkboxStyle} />;
}
